export const chattingKeys = {
  all: ["chatting"] as const,
};

export const chatMessageKeys = {
  all: ["chatMessage"] as const,
};
